// extracted by mini-css-extract-plugin
module.exports = {"container":"Marketplace_container__3UqZz","header":"Marketplace_header__349iX","wrapper":"Marketplace_wrapper__3FNB0"};